module.exports = __webpack_public_path__ + "static/img/IPimg6.ca139825.png";